/* Javascript that apply's to all pages with Janus Henderson Custom Blocks */

jQuery(document).ready(function ($) {
	// Keep the "is-layout-flow" blocks spacing for non jh-row-blocks.
	$(".main-block-layout .jh-row-block").each(function () {
		const $prev = $(this).prev();
		if ($prev.length && !$prev.hasClass("jh-row-block")) {
			$prev.addClass("layout-flow-bottom-margin");
		}
	});

	// If next block "has-offset-title" we need to add extra padding to makeup for the offset title.
	// Also ensure each has-offset-title block stacks above its predecessor (DOM order = correct stacking).
	$(".main-block-layout .has-offset-title").each(function () {
		const $prev = $(this).prev();
		if ($prev.length) {
			// Get the current computed padding-bottom value
			const currentPaddingBottom =
				parseInt($prev.css("padding-bottom")) || 0;
			// Add 91px to the existing padding
			const newPaddingBottom = currentPaddingBottom + 60;
			// Set the new padding-bottom inline to override any CSS
			$prev.css("padding-bottom", newPaddingBottom + "px");
			// Add a class for potential styling needs
			$prev.addClass("next-element-has-offset-title");

			// Ensure this block's z-index is above the previous block's so the
			// offset title overlaps correctly regardless of block order.
			const prevZ = parseInt($prev.css("z-index")) || 0;
			const selfZ = parseInt($(this).css("z-index")) || 0;
			if (prevZ >= selfZ) {
				$(this).css("z-index", prevZ + 1);
			}
		}
	});
});
